const sortByKey = (list, key) => {
  if (!list?.length) return [];

  return [...list].sort((a, b) => {
    const x = a[key];
    const y = b[key];

    // Try numeric comparison first
    const numX = Number(x);
    const numY = Number(y);

    if (!isNaN(numX) && !isNaN(numY)) {
      return numX - numY;
    }

    // Fall back to string comparison
    return x < y ? -1 : x > y ? 1 : 0;
  });
};

export const sortByKeyCallback = (key) => (a, b) => {
  let procA = key ? a?.[key] : a;
  let procB = key ? b?.[key] : b;

  return procA < procB ? -1 : procA > procB ? 1 : 0;
};

export default sortByKey;
